<nav
  class="staff-cabinet-more-menu"
  [attr.aria-label]="'STAFF.CABINET.MORE.TITLE' | translate"
>
  @for (item of menuItems(); track item.route) {
    <a class="staff-cabinet-more-menu__item" [routerLink]="navLink(item.route)">
      <span class="staff-cabinet-more-menu__icon-wrap" aria-hidden="true">
        <img
          class="staff-cabinet-more-menu__icon"
          [src]="itemIcon(item)"
          alt=""
          width="20"
          height="20"
        />
      </span>

      <span class="staff-cabinet-more-menu__label">
        {{ item.labelKey | translate }}
      </span>

      @if (badgeCount(item) > 0 && badgeLabelKey(item); as badgeKey) {
        <span
          class="staff-cabinet-more-menu__badge"
          [class.staff-cabinet-more-menu__badge--debtors]="isDebtorsBadge(item)"
          [attr.aria-label]="badgeKey | translate: { count: badgeCount(item) }"
        >
          {{ badgeCount(item) }}
        </span>
      }

      <span class="staff-cabinet-more-menu__chevron" aria-hidden="true">→</span>
    </a>
  }
</nav>
